import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQ = () => {
  const faqs = [
    {
      question: 'What printing and customization techniques do you offer?',
      answer:
        'We offer several high-quality printing techniques including Direct-To-Garment (DTG) printing with top-of-the-range Brother and Kornit machines using eco-friendly, water-based inks for vibrant long-lasting designs. We also provide Direct-To-Film (DTF) printing with premium transfer films and advanced heat press equipment for accurate, durable prints.',
    },
    {
      question: 'Can I get custom labels, hang tags, and branded packaging?',
      answer:
        'Yes! Custom labels are available and can be added to your orders. Hang tags, branded packaging bags, and printed inserts are currently in development. Subscribe to our newsletter to be the first to hear about new services and features.',
    },
    {
      question: 'Do you offer samples?',
      answer:
        "We don't offer sample orders specifically, but our minimum order quantity (MOQ) is just one item. This means you can choose any product you'd like to try and order a single piece, allowing you to personally experience the quality of our products and printing before ordering more.",
    },
    {
      question: 'Do you handle returns when I dropship to customers?',
      answer:
        "While Coastal Route handles returns in cases of manufacturing defects or order errors, we don't process returns directly from your customers. If you're a reseller or dropshipping partner, you'll manage customer returns based on your store policies.",
    },
    {
      question: 'Will my customers know the products come from Coastal Route?',
      answer:
        "No, your customers won't know the products come from Coastal Route. They will arrive with your designs, under your brand, with no mention of Coastal Route. We offer white-label fulfillment so you can build your brand identity.",
    },
    {
      question: 'How can I start a dropshipping business with Coastal Route?',
      answer:
        "It's simple! 1) Contact us to set up your account. 2) Connect your e-commerce platform (Shopify, WooCommerce, etc.) with our system. 3) Choose products from our catalog and upload your custom designs. 4) Set your pricing and profit margins. 5) Start selling - when customers order, we'll handle production, packaging, and shipping directly to your clients.",
    },
    {
      question: 'Will my store orders automatically sync with Coastal Route?',
      answer:
        'Yes! Coastal Route integrates seamlessly with popular e-commerce platforms. Once your store is connected, orders will automatically sync with our system for efficient fulfillment. Real-time tracking information is also synced back to your store.',
    },
    {
      question: 'What are your shipping times and costs?',
      answer:
        'Most orders are produced and shipped within 2-4 business days from our Tacoma, WA fulfillment center. Shipping times vary by destination - typically 3-5 days for US domestic and 7-14 days for international. We offer competitive shipping rates and real-time tracking for all orders.',
    },
  ];

  return (
    <section
      data-testid="faq-section"
      className="py-24 md:py-32 bg-white"
    >
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2
            data-testid="faq-heading"
            className="font-heading text-3xl md:text-4xl lg:text-5xl tracking-tight font-bold text-coastal-navy mb-6"
          >
            Frequently asked{' '}
            <span className="text-coastal-orange">questions</span>
          </h2>
          <p className="text-lg text-gray-600">
            Have more questions? Feel free to{' '}
            <a
              href="#contact"
              className="text-coastal-orange hover:underline font-medium"
            >
              contact us
            </a>
            .
          </p>
        </div>

        {/* Accordion */}
        <Accordion
          data-testid="faq-accordion"
          type="single"
          collapsible
          className="space-y-4"
        >
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              data-testid={`faq-item-${index}`}
              className="bg-coastal-offwhite border border-gray-200 rounded-2xl px-6 overflow-hidden"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${index}`}
                className="text-left font-heading font-semibold text-coastal-navy hover:text-coastal-orange py-5 [&[data-state=open]]:text-coastal-orange"
              >
                {faq.question}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-content-${index}`}
                className="text-gray-600 leading-relaxed pb-5"
              >
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
